import { render, staticRenderFns } from "./DataListAssurances.vue?vue&type=template&id=4dbe5a9a&scoped=true&"
import script from "./DataListAssurances.vue?vue&type=script&lang=js&"
export * from "./DataListAssurances.vue?vue&type=script&lang=js&"
import style0 from "./DataListAssurances.vue?vue&type=style&index=0&id=4dbe5a9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbe5a9a",
  null
  
)

export default component.exports